import { get } from 'lodash';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type {
  ComponentSettingsTab,
  OnChangeSettingsArgs,
} from 'hb-builder/types/settings';
import { BUTTON_VARIANT_OPTIONS } from 'hb-react/backoffice/types/builder/itemAttributes/buttonItemAttributes';

export type ButtonVariantProps = Pick<
  ComponentSettingsTab,
  'item' | 'onChange'
> &
  Pick<OnChangeSettingsArgs, 'settingKey'> & {
    defaultValue: BUTTON_VARIANT_OPTIONS;
    title: string;
  };

export const options = ({ includeInversed }) =>
  [
    { label: s__('Builder|Primary'), value: BUTTON_VARIANT_OPTIONS.PRIMARY },
    {
      label: s__('Builder|Secondary'),
      value: BUTTON_VARIANT_OPTIONS.SECONDARY,
    },
    includeInversed && {
      label: s__('Builder|Inversed'),
      value: BUTTON_VARIANT_OPTIONS.INVERSED,
    },
  ].filter(Boolean);

const ButtonVariant = ({
  defaultValue,
  item,
  includeInversed,
  onChange,
  settingKey = 'variant',
  title,
}: ButtonVariantProps & { includeInversed?: boolean }) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(get(item.attributes, settingKey));
  }, [item.attributes, settingKey]);

  const handleChange = (e) => {
    setValue(e.value);

    onChange({
      id: item.id,
      settingKey: `attributes.${settingKey}`,
      value: e.value,
    });
  };

  const formattedValue = getReactSelectValue(
    options({ includeInversed }),
    value,
  );

  return (
    <Wrapper data-testid="setting-styling-variant">
      <InputTitle id="settingsButtonVariant" label={title} position="left" />
      <ReactSelectInput
        id="settingsButtonVariant"
        name="settingsButtonVariant"
        onChange={handleChange}
        options={options({ includeInversed })}
        placeholder={value}
        value={formattedValue}
        variant="small"
        width={155}
      />
    </Wrapper>
  );
};

export default ButtonVariant;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
